import { Box, Typography } from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";

interface HeaderProps {
    title: string,
    children?: React.ReactNode,
    className?: string,
}

export default function Header(props: HeaderProps) {
    const theme = useTheme();
    return (
        <Box sx={{ width: '100%', bgcolor: '#2F3D4C', height: '55px', display: 'flex', flexDirection: 'row' }}>
            <Typography sx={{ p: 1, color: '#EEE' }} variant='h4'>{props.title}</Typography>
            <Box sx={{ flex: 1 }} />
            <Box sx={{ p: 1, alignItems: 'center', justifyContent: 'flex-end' }}>
                {props.children}
            </Box>
        </Box>
    );
}